import { useEffect, useRef } from "react";
import useWebSocket from "react-use-websocket";
import { toast } from "react-toastify";
import { STATUS } from "../components/constants/statuses";

const useWebSocketNotification = (id, isDj = false, refreshRequests) => {
  const ws = process.env.REACT_APP_API_WS_URL;
  const socketUrl = `${ws}/ws?${isDj ? "djId" : "userId"}=${id}`;
  const { lastMessage } = useWebSocket(socketUrl, {
    shouldReconnect: () => true,
  });
  const lastProcessedMessageRef = useRef(null);

  useEffect(() => {
    if (lastMessage) {
      const data = JSON.parse(lastMessage.data);

      if (lastProcessedMessageRef.current === lastMessage.data) {
        return;
      }

      lastProcessedMessageRef.current = lastMessage.data;

      if (!isDj) {
        if (data.requestId) {
          if (data.status === STATUS.APPROVED) {
            refreshRequests();
            toast.success("Your request was approved");
          } else if (data.status === STATUS.REJECTED) {
            refreshRequests();
            toast.error("Your request was rejected");
          } else if (data.status === STATUS.PLAYED) {
            refreshRequests();
            toast.info("Your request was played");
          }
        }
      } else {
        if (data.type === "NEW_REQUEST") {
          refreshRequests();
          toast.success("You have a new request");
        } else if (data.type === "PAYMENT_NOTICE") {
          refreshRequests();
          toast.warning("Request was paid");
        }
      }
    }
  }, [lastMessage, refreshRequests]);

  return {};
};

export default useWebSocketNotification;
